import * as React from "react";
import Div from "@jumbo/shared/Div";
import TopNavBar from "app/components/TopNavBar/TopNavBar";
import ContentWrapper from "app/components/ContentWrapper/ContentWrapper";
import ButtonStyled from "app/components/ButtonStyled/ButtonStyled";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Chip from "@mui/material/Chip";
import { Avatar, Typography } from "@mui/material";
import InputForm from "app/components/InputForm/InputForm";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import { requestApi } from "app/utils/RestApi";
import { AUTH, OTP, REFERRER } from "app/utils/constants/endPoint";
import { removeToken } from "@jumbo/components/JumboAuthProvider/authHelpers";
import Swal from "sweetalert2";
import CreateIcon from "@mui/icons-material/Create";
import { formatString } from "app/utils/appHelpers";
import Footer from "app/components/Footer";

function MicrositeProfile(props) {
  let [userLoggedin, setUser] = React.useState({});

  const navigate = useNavigate();

  React.useEffect(() => {
    initData();
    document.querySelector("html").classList.add("overflow-hidden");
  }, []);

  const initData = async () => {
    // const otp = sessionStorage.getItem("otp_temp");
    // if (otp) {
    //   const { data } = await requestApi(OTP.VERIFY_OTP_REF, {
    //     data: {
    //       username: localStorage.getItem("username"),
    //       otp: otp,
    //     },
    //   });
    //   if (data.status !== "success") {
    //     sessionStorage.removeItem("otp_temp");
    //     removeToken();
    //   }
    // }

    const userdata = localStorage.getItem("userdata");
    let ls_userdata = {};
    let id = "";
    if (userdata) {
      ls_userdata = JSON.parse(userdata);
      console.log("initdata userdata : ", ls_userdata.userLoggedin);
      id = ls_userdata.userLoggedin.id;
    }

    if (id) {
      try {
        const { data } = await requestApi(REFERRER.DETAIL, {
          subfolder: "/" + id,
        });

        console.log("ref detail : ", data);
        if (data.status === "success") {
          localStorage.setItem(
            "userdata",
            JSON.stringify({
              ...ls_userdata,
              userLoggedin: data.data,
            })
          );
          setUser(data.data);
        }
      } catch (error) {
        console.log("error : ", error);
        // Swal.fire({
        //   icon: "warning",
        //   text: error ? (error?.message || "Bad request!") : "I",
        //   title: "Error",
        //   allowOutsideClick: false,
        //   confirmButtonColor: "red",
        // })
      }
    }
  };

  const toChangePassword = () => {
    navigate("/micrositeUbahPassword");
  };

  const toTnc = () => {
    navigate("/micrositeSyaratKetentuan");
  };

  const toEdit = () => {
    navigate("/micrositeProfileEdit");
  };

  const onLogout = async () => {
    Swal.showLoading();
    await requestApi(AUTH.LOGOUT, {})
      .then((data) => {})
      .catch((err) => {
        console.log("logout err ", err);
      })
      .finally(() => {
        setTimeout(() => {
          Swal.close();
          removeToken();
        }, 3000);
      });
  };

  const toNews = () => {
    navigate("/micrositeNews");
  };

  return (
    <Div className="page-wrapper profile-page">
      <TopNavBar activeMenu={1} />
      <ContentWrapper className="wrapper-profile">
        <Div>
          <Div className="bg-profile">
            <Div>
              <Div>
                <Div className="w-100 profile-data">
                  <Row>
                    <Col lg={6} md={8}>
                      <Div
                        className="flex-justify-start"
                        sx={{ alignItems: "flex-start" }}
                      >
                        <Div className="back-icon-profile">
                          <KeyboardBackspaceIcon onClick={toNews} />
                        </Div>
                        <Div className="profile-detail">
                          <Avatar sx={{ width: 90, height: 90 }} />
                        </Div>
                        <Div className="profile-name">
                          <Typography
                            fontSize={20}
                            fontWeight={600}
                            color={"white"}
                          >
                            Selamat Datang, {userLoggedin?.name}!
                          </Typography>
                          <Typography
                            fontSize={16}
                            fontWeight={400}
                            color={"white"}
                          >
                            {userLoggedin?.name}
                          </Typography>
                          <Typography
                            fontSize={16}
                            fontWeight={400}
                            color={"white"}
                          >
                            {userLoggedin?.phoneNumber}
                          </Typography>
                          <Typography
                            fontSize={16}
                            fontWeight={400}
                            color={"white"}
                          >
                            {userLoggedin?.email}
                          </Typography>
                        </Div>
                      </Div>
                    </Col>
                    <Col className="profile-right" lg={6} md={4}>
                      <Row>
                        <Col lg={4} md={12} xs={6}>
                          <Div sx={{ mt: 4 }}>
                            <Typography
                              fontSize={14}
                              fontWeight={400}
                              color={"white"}
                            >
                              Kode Referral
                            </Typography>
                            <Typography
                              fontSize={20}
                              fontWeight={600}
                              color={"white"}
                            >
                              {userLoggedin?.referrerCode}
                            </Typography>
                          </Div>
                        </Col>
                        <Col lg={4} md={12} xs={6}>
                          <Div className="profile-status">
                            <Typography
                              fontSize={14}
                              fontWeight={400}
                              color={"white"}
                            >
                              Status
                            </Typography>
                            <Chip
                              label="Active"
                              size="small"
                              color="success"
                              sx={{ borderRadius: "5px" }}
                              className="active-ref"
                            />
                          </Div>
                        </Col>
                        <Col lg={4} md={12} xs={6}>
                          <Div
                            className="profile-status"
                            style={{ cursor: "pointer" }}
                            onClick={toEdit}
                          >
                            <Typography
                              fontSize={16}
                              fontWeight={400}
                              color={"white"}
                            >
                              Edit <CreateIcon />
                            </Typography>
                          </Div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Div>
              </Div>
            </Div>
          </Div>
          <Div
            className="content-padding"
            sx={{ background: "#ffffff", borderRadius: "0 0 15px 15px" }}
          >
            <Row>
              <Col lg={6} md={12}>
                <InputForm
                  sx={{ mb: 4 }}
                  inputLabel={"No. Identitas"}
                  placeholder={"No. Identitas"}
                  size={"small"}
                  disabled
                  value={userLoggedin?.ktpNumber}
                />
              </Col>
              <Col lg={6} md={12}>
                <InputForm
                  sx={{ mb: 4 }}
                  inputLabel={"Nama Bank"}
                  placeholder={"Nama Bank"}
                  size={"small"}
                  disabled
                  value={userLoggedin?.bankName}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={6} md={12}>
                <InputForm
                  sx={{ mb: 4 }}
                  inputLabel={"Tanggal Lahir"}
                  placeholder={"Tanggal Lahir"}
                  size={"small"}
                  disabled
                  value={`${moment(userLoggedin?.birthDate).format(
                    "DD-MM-YYYY"
                  )}`}
                />
              </Col>
              <Col lg={6} md={12}>
                <InputForm
                  sx={{ mb: 4 }}
                  inputLabel={"No. Rekening"}
                  placeholder={"No. Rekening"}
                  size={"small"}
                  disabled
                  value={userLoggedin?.accountNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={6} md={12}>
                <InputForm
                  sx={{ mb: 4 }}
                  inputLabel={"NPWP"}
                  placeholder={"NPWP"}
                  size={"small"}
                  disabled
                  value={
                    userLoggedin?.npwpNumber
                      ? formatString(userLoggedin?.npwpNumber)
                      : "-"
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col></Col>
            </Row>
            <Div>
              <Row>
                <Col lg={6} md={12}>
                  <Div className="card-custom" sx={{ mt: 4 }}>
                    <Div className="p-4">
                      <Typography
                        fontSize={20}
                        fontWeight={600}
                        color={"black"}
                      >
                        Info Agen
                      </Typography>
                      <InputForm
                        sx={{ mb: 2, mt: 2 }}
                        inputLabel={"Nama Agen"}
                        placeholder={"Nama Agen"}
                        size={"small"}
                        disabled
                        value={userLoggedin?.agent?.name}
                      />
                      <InputForm
                        inputLabel={"Nomor HP"}
                        placeholder={"Nomor HP"}
                        size={"small"}
                        disabled
                        value={userLoggedin?.agent?.phoneNumber}
                      />
                    </Div>
                  </Div>
                </Col>
                <Col lg={6} md={12}>
                  <Div className="card-custom" sx={{ mt: 4 }}>
                    <Div className="p-4">
                      <Typography
                        fontSize={20}
                        fontWeight={600}
                        color={"black"}
                      >
                        Menu Lainnya
                      </Typography>
                      <Div sx={{ mt: 2 }}>
                        <ButtonStyled
                          onClick={toTnc}
                          btnText={"Syarat Dan Ketentuan"}
                          sx={{ maxWidth: "100%" }}
                          preset={"primary"}
                        />
                      </Div>
                      <Div sx={{ mt: 2 }}>
                        <ButtonStyled
                          onClick={toChangePassword}
                          btnText={"Ubah Kata Sandi"}
                          sx={{ maxWidth: "100%" }}
                          preset={"primary"}
                        />
                      </Div>
                      <Div sx={{ mt: 2 }}>
                        <ButtonStyled
                          onClick={onLogout}
                          btnText={"Keluar"}
                          sx={{ maxWidth: "100%" }}
                          preset={"primary"}
                        />
                      </Div>
                    </Div>
                  </Div>
                </Col>
              </Row>
            </Div>
          </Div>
        </Div>
      </ContentWrapper>
      <Footer />
    </Div>
  );
}

const mapStateToProps = (state) => ({
  authMicrosite: state.authMicrosite,
});

export default connect(mapStateToProps)(MicrositeProfile);
